import React, { createContext, useContext, useState, useEffect } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState(() => {
    const saved = localStorage.getItem('notifications');
    return saved ? JSON.parse(saved) : {
      email: {
        enabled: true,
        journalReminders: true,
        connectionUpdates: true,
        calendarEvents: true,
        weeklySummary: false
      },
      push: {
        enabled: false,
        journalReminders: false,
        connectionUpdates: false,
        calendarEvents: false,
        weeklySummary: false
      },
      inApp: {
        enabled: true,
        journalReminders: true,
        connectionUpdates: true,
        calendarEvents: true,
        weeklySummary: true
      }
    };
  });

  useEffect(() => {
    localStorage.setItem('notifications', JSON.stringify(notifications));
  }, [notifications]);

  const updateNotification = (category, type, value) => {
    setNotifications(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [type]: value
      }
    }));
  };

  const toggleAllNotifications = () => {
    const anyEnabled = notifications.email.enabled || notifications.push.enabled || notifications.inApp.enabled;
    const newState = anyEnabled ? false : true;
    
    setNotifications(prev => ({
      email: { ...prev.email, enabled: newState },
      push: { ...prev.push, enabled: newState },
      inApp: { ...prev.inApp, enabled: newState }
    }));
  };

  const areAnyNotificationsEnabled = () => {
    return notifications.email.enabled || notifications.push.enabled || notifications.inApp.enabled;
  };

  return (
    <NotificationContext.Provider value={{ 
      notifications, 
      updateNotification, 
      toggleAllNotifications,
      areAnyNotificationsEnabled 
    }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
